import {
    Form,
    Row,
    Col,
    Button,
    InputGroup,
    Alert
} from "react-bootstrap";

import BreadcrumbEstadistica from "./BreadcrumbEstadistica";
import MaoTable from "../common/MaoTable";
import { getEvolucion } from "../../services/EvolucionService";
import { getMarcas } from "../../services/MarcasService";
import ChartEvolucion from "../common/ChartEvolucion";
import { useNavigate } from "react-router-dom";
import { parseNumeroEntero } from "../../utils/NumberUtils";

import {
    useState,
    useEffect
} from "react";

import {
    formatNumber
} from "../../utils/NumberUtils";

import {
    getFechaInicioMes,
    getFechaHoy,
    getMesFromNumero
} from "../../utils/DateUtils";
import GraficoLineas from "./GraficoLineas";

function EvolucionVentas() {

    const [evolucion, setEvolucion] = useState([]);

    const [error, setError] = useState("");

    const [fechaDesde, setFechaDesde] =
    useState(
        `${new Date().getFullYear()}-01-01`
    );

    const [fechaHasta, setFechaHasta] =
        useState(getFechaHoy());

    const [mostrarGraficas, setmostrarGraficas] =
        useState(false);

    const [marcas, setMarcas] = useState([]);

    const [marca, setMarca] = useState("");

    const [columnas, setColumnas] = useState([]);

    const navigate = useNavigate();

    // =========================
    // CARGAR MARCAS
    // =========================

    useEffect(() => {

        getMarcas()
            .then((resp) => {

                if (resp.error) {

                    setError(resp.message);

                } else {

                    setMarcas(resp.data);
                }
            });

    }, []);

    // =========================
    // REGENERAR COLUMNAS
    // =========================



    // =========================
    // CARGA INICIAL
    // =========================

    useEffect(() => {

        EvolucionVentasInicio();

    }, []);

    // =========================
    // VOLVER
    // =========================

    function volver() {

        navigate("/estadistica");
    }

    // =========================
    // ARMAR COLUMNAS DINAMICAS
    // =========================

    function determinarColumnas(fechaDesdeParam, fechaHastaParam) {

        let newColumnas = [];

        newColumnas.push({
            titulo: "Concepto",
            atributo: "titulo"
        });

        const [anioDesde, mesDesde] =
            fechaDesdeParam.split("-").map(Number);

        const [anioHasta, mesHasta] =
            fechaHastaParam.split("-").map(Number);

        let fechaActual = new Date(
            anioDesde,
            mesDesde - 1,
            1
        );

        while (
            fechaActual.getFullYear() < anioHasta
            ||
            (
                fechaActual.getFullYear() === anioHasta
                &&
                fechaActual.getMonth() <= mesHasta - 1
            )
        ) {

            let mes = fechaActual.getMonth() + 1;
            let anio = fechaActual.getFullYear();

            let clave = `${anio}-${mes}`;

            newColumnas.push({
                titulo: `${getMesFromNumero(mes)} ${anio}`,
                atributo: clave,
                className: "col-importe",
                //funcion: (valor) => formatNumber(valor ?? 0)
            });

            fechaActual.setMonth(
                fechaActual.getMonth() + 1
            );
        }

        newColumnas.push({
            titulo: "Total",
            atributo: "totalGeneral",
            className: "col-importe col-bold"
        });

        setColumnas(newColumnas);
    }

    // =========================
    // CARGA INICIAL
    // =========================

    async function EvolucionVentasInicio() {

        setmostrarGraficas(true);

        let resp = await getEvolucion(
            fechaDesde,
            fechaHasta,
            marca
        );

        if (resp.error) {

            setError(resp.message);

            setEvolucion([]);

        } else {

            setError("");

            determinarColumnas(
                fechaDesde,
                fechaHasta
            );

            transformarDatos(
                resp.data,
                fechaDesde,
                fechaHasta
            );
        }
    }

    // =========================
    // BUSCAR
    // =========================

    async function buscar() {

        setmostrarGraficas(true);

        let fechaDesdeParam =
            document.getElementById(
                'fechaDesde'
            ).value;

        let fechaHastaParam =
            document.getElementById(
                'fechaHasta'
            ).value;

        let marcaParam =
            document.getElementById(
                'selMarca'
            ).value;

        let pendientesParam =
            document.getElementById(
                'chkIncluirPendientes'
            ).checked;

        let montoEnDolaresParam =
            document.getElementById(
                'chkMostrarMontoEnDolares'
            ).checked;

        let resp = await getEvolucion(
            fechaDesdeParam,
            fechaHastaParam,
            marcaParam,
            pendientesParam,
            montoEnDolaresParam
        );

        if (resp.error) {

            setError(resp.message);

            setEvolucion([]);

        } else {

            setError("");

            determinarColumnas(
                fechaDesdeParam,
                fechaHastaParam
            );
            transformarDatos(
                resp.data,
                fechaDesdeParam,
                fechaHastaParam
            );
        }
    }

    // =========================
    // TRANSFORMAR DATOS
    // =========================

    function transformarDatos(data, fechaDesdeParam, fechaHastaParam) {

        let filaTotal = {

            titulo: "Total"
        };

        let filaComisiones = {

            titulo: "Comisiones"
        };

        let filaCantidad = {

            titulo: "Cant. Pedidos"
        };

        let totalGeneral = 0;

        let totalComisiones = 0;

        let totalCantidad = 0;

        const [anioDesde, mesDesde] =
            fechaDesdeParam.split("-").map(Number);

        const [anioHasta, mesHasta] =
            fechaHastaParam.split("-").map(Number);

        let fechaActual = new Date(
            anioDesde,
            mesDesde - 1,
            1
        );

        while (
            fechaActual.getFullYear() < anioHasta
            ||
            (
                fechaActual.getFullYear() === anioHasta
                &&
                fechaActual.getMonth() <= mesHasta - 1
            )
        ) {

            let clave =
                `${fechaActual.getFullYear()}-${fechaActual.getMonth() + 1}`;

            filaTotal[clave] = 0;

            filaComisiones[clave] = 0;

            filaCantidad[clave] = 0;

            fechaActual.setMonth(
                fechaActual.getMonth() + 1
            );
        }

        // RECORRER RESPUESTA

        for (let i = 0; i < data.length; i++) {

            let item = data[i];

            // SI TU API DEVUELVE:
            // item.anio
            // item.mes

            let clave =
                `${item.anio}-${item.mes}`;

            filaTotal[clave] = Number(item.total ?? 0)
                //Number(item.total) ?? formatNumber(item.total);

            filaComisiones[clave] = Number(item.comisiones ?? 0)
                //Number(item.comisiones) ?? formatNumber(item.comisiones);

            filaCantidad[clave] = parseInt(item.cantidad ?? 0)
                //item.cantidad;

            totalGeneral +=
                parseFloat(item.total);

            totalComisiones +=
                parseFloat(item.comisiones);

            totalCantidad +=
                parseInt(item.cantidad);
        }

        // TOTALES

        filaTotal.totalGeneral =
            formatNumber(totalGeneral);

        filaComisiones.totalGeneral =
            formatNumber(totalComisiones);

        filaCantidad.totalGeneral =
            totalCantidad;

        // SETEAR DATOS

        setEvolucion([
            filaTotal,
            filaComisiones,
            filaCantidad
        ]);
    }

    const evolucionTabla = evolucion.map(fila => {
        if (fila.titulo === "Cant. Pedidos") {
            return fila;
        }

        const nuevaFila = { ...fila };

        Object.keys(nuevaFila).forEach(key => {
            if (key !== "titulo" && key !== "totalGeneral") {
                nuevaFila[key] = formatNumber(nuevaFila[key] ?? 0);
            }
        });

        return nuevaFila;
    });

    // =========================
    // FECHAS
    // =========================

    const handleFechaDesdeChange = (e) => {

        e.preventDefault();

        setmostrarGraficas(false);

        setFechaDesde(e.target.value);
    };

    const handleFechaHastaChange = (e) => {

        e.preventDefault();

        setmostrarGraficas(false);

        setFechaHasta(e.target.value);
    };

    // =========================
    // RENDER
    // =========================

    return (

        <div>

            <BreadcrumbEstadistica
                active="Evolución de Ventas"
            />

            <Form>

                <Row
                    className=
                    "d-flex align-items-center"
                >

                    {/* FECHA DESDE */}

                    <Col xs="auto" md="4">

                        <InputGroup
                            className="mb-2"
                        >

                            <InputGroup.Text
                                className=
                                "btn btn-secondary"
                                style={{
                                    width: '5em'
                                }}
                            >
                                Desde
                            </InputGroup.Text>

                            <Form.Control
                                type="date"
                                id="fechaDesde"
                                value={fechaDesde}
                                onChange={
                                    handleFechaDesdeChange
                                }
                            />

                        </InputGroup>

                    </Col>

                    {/* FECHA HASTA */}

                    <Col xs="auto" md="4">

                        <InputGroup
                            className="mb-2"
                        >

                            <InputGroup.Text
                                className=
                                "btn btn-secondary"
                                style={{
                                    width: '5em'
                                }}
                            >
                                Hasta
                            </InputGroup.Text>

                            <Form.Control
                                type="date"
                                id="fechaHasta"
                                value={fechaHasta}
                                onChange={
                                    handleFechaHastaChange
                                }
                            />

                        </InputGroup>

                    </Col>

                    {/* MARCAS */}

                    <Col xs="auto" md="4">

                        <InputGroup
                            className="mb-2"
                        >

                            <Form.Select
                                id="selMarca"
                                value={marca}
                                onChange={(e) => {

                                    setMarca(
                                        e.target.value
                                    );
                                }}
                            >

                                <option value="">
                                    Todas las marcas
                                </option>

                                {
                                    marcas.map((m) =>

                                        <option
                                            key={m.marca_id}
                                            value={m.marca_id}
                                        >
                                            {m.nombre}
                                        </option>
                                    )
                                }

                            </Form.Select>

                        </InputGroup>

                    </Col>

                    {/* PENDIENTES */}

                    <Col xs="auto" md = "4" className="text-start">

                        <Form.Check
                            type="checkbox"
                            id="chkIncluirPendientes"
                            label=
                            "Incluir Pendientes"
                            onClick={buscar}
                        />

                    </Col>

                    <Col xs="auto" md= "4" className="text-start">

                        <Form.Check
                            type="checkbox"
                            id="chkMostrarMontoEnDolares"
                            label=
                            "Mostrar Monto en Dólares"
                            onClick={buscar}
                        />

                    </Col>

                    {/* BUSCAR */}

                    <Col xs="auto" md="4">

                        <Button 
                            style={{ width: '100%' }}
                            onClick={buscar}
                        >
                            Buscar
                        </Button>

                    </Col>

                </Row>

                {/* ERROR */}

                {
                    error !== ''
                        ?
                        <Row>

                            <Col xs="auto">

                                <Alert
                                    variant="danger"
                                >
                                    {error}
                                </Alert>

                            </Col>

                        </Row>
                        :
                        <></>
                }

            </Form>

            {/* TABLA */}

            <MaoTable
                columnas={columnas}
                datos={evolucionTabla}
                colId="titulo"
            />

            {/* GRAFICAS */}

            {
                mostrarGraficas
                    ?
                    
                        <>
                            {evolucion.length >= 3 && (
                                <Row className='mt-4 mb-4'>
                                    <Col md="6" xs="12">
                                        <ChartEvolucion
                                            titulo="Evolución de Ventas"
                                            tituloSerie="Ventas"
                                            serie={evolucion[0]
                                                ? Object.values(evolucion[0]).slice(1, -1)
                                                : []
                                            }
                                            labels={columnas.slice(1, -1).map(col => col.titulo)}
                                        />
                                    </Col>
                                    <Col md="6" xs="12">
                                        <ChartEvolucion
                                            titulo="Evolución de Comisiones"
                                            tituloSerie="Comisiones"
                                            serie={evolucion[1]
                                                ? Object.values(evolucion[1]).slice(1, -1)
                                                : []
                                            }
                                            labels={columnas.slice(1, -1).map(col => col.titulo)}
                                        />
                                    </Col>
                                    <Col md="3" xs="0"></Col>
                                    <Col md="6" xs="12">
                                        <ChartEvolucion
                                            titulo="Cantidad de Pedidos"
                                            tituloSerie="Pedidos"
                                            serie={evolucion[2]
                                                ? Object.values(evolucion[2]).slice(1, -1).map(num => parseNumeroEntero(num))   
                                                : []
                                            }
                                            labels={columnas.slice(1, -1).map(col => col.titulo)}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </>
                    :
                    <div className="error">
                        Presione Buscar
                        para actualizar
                    </div>
            }

            {/* VOLVER */}

            <div
                className=
                "d-flex justify-content-center"
            >

                <Button onClick={volver}>
                    Volver
                </Button>

            </div>

        </div>
    );
}

export default EvolucionVentas;